import React from 'react';
import { Button, Icon, Box } from '@amzn/awsui-components-core';

interface Props {
  like: number;
  dislike: number;
}

const likedSvgPath = '/images/thumb-up.svg';
const dislikedSvgPath = '/images/thumb-down.svg';

const CollectionCardLikeDislike = ({ like, dislike }: Props) => {
  const renderLike = () => {
    if (!!like) {
      return (
        <Box variant="span" padding={{ right: 'xs' }}>
          <Icon url={likedSvgPath} alt="Likes" />
          <span className="collection-card-count">{like}</span>
        </Box>
      );
    }
    return null;
  };

  const renderDislike = () => {
    if (!!dislike) {
      return (
        <Box variant="span" padding={{ right: 'xs' }}>
          <Icon url={dislikedSvgPath} alt="Dislikes" />
          <span className="collection-card-count">{dislike}</span>
        </Box>
      );
    }
    return null;
  };

  return (
    <>
      {renderLike()}
      {renderDislike()}
    </>
  );
};

export default CollectionCardLikeDislike;
